export default __webpack_public_path__ + "static/media/Captain's Chestplate of Dynastic Rule.5341e49d.jpg";